import styled from 'styled-components'

interface ContainerProps {
    saleisover?: boolean
}

export const Container = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'saleisover',
})<ContainerProps>`
    display: flex;
    width: 100%;
    height: min-content;
    max-height: 300px;
    border: 1px solid #e2e8f0; /* Optional, for visual separation */
    border-radius: 8px; /* Optional, for rounded corners */
    background: #fff; /* Optional, for background color */
    justify-content: space-between;
    background: ${({ saleisover }) => (saleisover ? '#f2f2f2ff' : '#fff')};
`

export const ImageContainer = styled.div`
    max-width: 386px;
    width: 24rem;
    flex-shrink: 0;
`

export const ImageComponent = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
`

export const WrapperColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`

export const WrapperRow = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
`

export const DetailsContainer = styled.div`
    flex: 2;
    padding: 10px 20px;
    padding-right: 0px;
    display: flex;
    flex-direction: column;
    min-width: 0;
`

export const ActionContainer = styled.div`
    flex: 1;
    padding: 10px 20px;
    padding-left: 0px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`

export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: flex-end;
`

export const Title = styled.h2`
    margin: 0;
    font-size: 36px;
    font-weight: 500;
    max-width: 40ch;
    margin: 0px 5px 10px 0px;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

export const LocationBox = styled.div`
    max-width: 30rem;
    height: fit-content;
    width: max-content;
    text-transform: uppercase;
    font-size: 12;
    font-weight: bold;
    padding: 10px 20px 10px 20px;
    color: #fff;
    border-radius: 4px;
    display: inline-block;
`

export const PriceText = styled.p`
    font-size: 14px;
    font-weight: 600;
    margin: 0;
`
export const PriceRangeText = styled.p`
    font-size: 14px;
    margin: 0;
    margin-left: 5px;
`
export const PriceRange = styled.div`
    display: flex;
    margin-top: 10px;
`

export const DateDisplay = styled.div`
    margin-top: 10px;
    font-size: 16px;
    font-weight: 600;
    color: #000;
`

export const TicketDataContainer = styled.div`
    padding: 10px 20px;
    padding-right: 0px;
    padding-bottom: 0px;
    display: flex;
    flex-direction: column;
`

export const TicketDataRow = styled.div`
    display: flex;
`

export const TicketDataLabel = styled.p`
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 600;
    padding-right: 5px;
`

export const TicketDataValue = styled.p`
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
`

export const TicketDataLarge = styled.p`
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 600;
    padding-right: 5px;
    margin: 0;
`

export const TicketDataValueLarge = styled.p`
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 600;
    margin: 0;
`

export const ProgressBar = styled.div`
    width: 100%;
    height: 16px;
    background-color: #edf2f7;
    margin-top: auto;
`
export const ProgressFill = styled.div<{ color: string; percentage: string }>`
    height: 100%;
    width: ${(props) => props.percentage};
    background-color: ${(props) => props.color};
`
